import { FilledInput, InputAdornment, TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { FunctionComponent, useEffect, useState } from "react";
import { UpdateMenuFlag } from "../../actions";
import { OptionsData } from "../../models/grid.model";
import { PlanMetrics } from "../../models/plan-metrics.model";
import { AppState } from "../../reducers/models";
import ButtonComponent from "./button/button.component";
import ButtonModel from "./button/button.model";
import Badge from "@mui/material/Badge";
import { FilterDarkIcon, FilterPrimaryIcon, BurgerMenuIcon, GridSearchIcon } from "../../icon";
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

interface IProps {
    HeaderText?: string;
    Reload?: () => void;
    Actions?: ButtonModel[];
    HandleFilter?: (e) => void;
    ShowFilterIcon?: boolean;
    Count?: number;
    ErrPage?: boolean;
    HideBurgerMenu?: boolean;
    onSearch?: (e) => void;
    ShowMultiActionButtons?: boolean;
    MultiActionButtons?: OptionsData[]
    GridTitle?: string;
    PlaceHolder?: string;
    IsFilterApplied?: any
    HideSearch?: boolean;
    searchValue?: string;
    TextFiledClassName?: string
}

const PageHeaderComponent: FunctionComponent<IProps> = (props: IProps) => {
    const dispatch = useDispatch()
    const PlanMetrics: PlanMetrics = useSelector(selector.planMetrics)
    const HeaderTitle: string = useSelector(selector.headerTitle)
    const HeaderCount: string = useSelector(selector.headerCount)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)


    const [showSearch, setShowSearch] = useState(false);
    const [hideSearch, setHideSearch] = useState(false);

    useEffect(() => {
        setShowSearch(!props.ShowMultiActionButtons)
    }, [props.ShowMultiActionButtons])

    const ToggleSearch = () => {
        setShowSearch(!showSearch);
    }

    useEffect(() => {
        if (!!props.HideSearch) {
            setHideSearch(true)
        }
        else {
            setHideSearch(false)
        }
    }, [props.HideSearch])

    return <div className={`d-flex w-fill flex-direction ${(props.ErrPage && IsMobileDevice) && 'paper-background'} my-auto ${IsMobileDevice ? 'px-1' : 'px-2'}`}>
        {IsMobileDevice && <div className="d-flex justify-between">
            <div className="d-flex">
                {!props.HideBurgerMenu &&
                    <span className={`py-1 pr-1 ${props.ErrPage && 'pl-2'} my-auto`} style={{ zIndex: 100 }}>
                        <BurgerMenuIcon onClick={(e) => { e.stopPropagation(); UpdateMenuFlag(dispatch, true); }} />
                    </span>}
                <div className={"d-flex my-auto"}>
                    <span className={`h3-semibold color-header-title-font w-space`}>
                        {props.HeaderText || HeaderTitle || ""}
                        {
                            (props.Count || HeaderCount) && <span className={`color-settings-nav-bar-option h3-semibold mx-1`}>
                                .
                            </span>
                        }
                        <span className='color-settings-nav-bar-option h5-medium my-auto mt-1'>
                            {props.Count !== undefined ? props.Count : HeaderCount !== undefined ? HeaderCount : ""}
                        </span>
                    </span>
                </div>
            </div>
            {(!!props.Actions || props.ShowFilterIcon) &&
                props.ShowFilterIcon && <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={props.HandleFilter} tabIndex={5}>
                    <Badge color="primary" overlap="circular" classes={{ colorPrimary: "bg-color-filter-selected" }} badgeContent={props.IsFilterApplied} >
                        {props.IsFilterApplied ? <FilterPrimaryIcon /> : <FilterDarkIcon />}
                    </Badge>
                </IconButton>}
        </div>}
        < div className="w-fill d-flex justify-between">
            <div className={`d-flex justify-between align-center my-auto ${props.TextFiledClassName}`}>
                {!IsMobileDevice && <div className="d-flex">
                    {/* <span className="d-flex color-header-title-font h4-semibold my-auto mr-1 w-space">{props.GridTitle}</span> */}
                    {props.ShowMultiActionButtons && !!props.MultiActionButtons && props.MultiActionButtons.map((btn: OptionsData, index: number) =>
                        !btn.Hide && <button className={`ml-1 grid-btn grid-btn-${btn.Variant} ${btn.ClassName}`} key={`${btn.Name}-${index}`} onClick={btn.OnClick}>
                            {!!btn.Icon && <btn.Icon className="w-2" />}
                            {btn.Name}
                        </button>)}</div>}
                {!hideSearch &&
                    (showSearch ?

                        <FilledInput
                            inputProps={{
                                tabIndex: 4,
                                "data-arrow-index": 2000,
                            }}
                            value={props.searchValue && props.searchValue}
                            size="medium"
                            fullWidth
                            className="m-auto filled-search-input bg-color-side-bar h5-medium"
                            placeholder={props.PlaceHolder}
                            onChange={props.onSearch}
                            startAdornment={<InputAdornment position="start">
                                <GridSearchIcon />
                            </InputAdornment>}
                            disableUnderline
                        />
                        :
                        <GridSearchIcon onClick={ToggleSearch} className="c-pointer" />)}
            </div>
            {(!!props.Actions || props.ShowFilterIcon) && <div className="d-flex justify-between">
                {!!props.Actions && props.Actions.map((x, i) => <ButtonComponent buttonProps={{ tabIndex: 5 + i, "data-up-arrow-index": 4 }} key={i} {...x} ClassName='w-space ml-1 teams-tutorial' />)}
                {!IsMobileDevice && props.ShowFilterIcon && <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={props.HandleFilter} tabIndex={5}>
                    <Badge color="primary" overlap="circular" classes={{ colorPrimary: "bg-color-filter-selected" }} badgeContent={props.IsFilterApplied} >
                        {props.IsFilterApplied ? <FilterPrimaryIcon /> : <FilterDarkIcon />}
                    </Badge>
                </IconButton>}
            </div>}
        </div>
    </div >
}

export default PageHeaderComponent;
